import { render } from "./aio-login-social-login.vue?vue&type=template&id=66fd0610&scoped=true"
import script from "./aio-login-social-login.vue?vue&type=script&lang=js"
export * from "./aio-login-social-login.vue?vue&type=script&lang=js"

import "./aio-login-social-login.vue?vue&type=style&index=0&id=66fd0610&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fd0610"]])

export default __exports__